import { createSelector, createFeatureSelector } from '@ngrx/store';
import { buildListMessage } from 'src/admin-app/utilities/list-filtering/list-message';
import { QuoteListState, quoteListFeatureKey } from './quote-list.reducer';

const getQuoteListState = createFeatureSelector<QuoteListState>(
	quoteListFeatureKey
);

export const getLoadingStatus = createSelector(
	getQuoteListState,
	(state: QuoteListState) => !state.isInitialized || state.isLoading
);

export const getListMessage = createSelector(
	getQuoteListState,
	getLoadingStatus,
	(state: QuoteListState, isLoading: boolean) =>
		buildListMessage(state.error, isLoading, state.pagesResults)
);

export const getFilteredAndPagedQuotes = createSelector(
	getQuoteListState,
	(state: QuoteListState) =>
		state.pagesResults ? state.pagesResults.results : []
);

export const getPagedQuotesCount = createSelector(
	getQuoteListState,
	(state: QuoteListState) =>
		state.pagesResults ? state.pagesResults.resultCount : 0
);

export const getListArgs = createSelector(
	getQuoteListState,
	(state: QuoteListState) => state.listArgs
);
